/* eslint-disable import/no-anonymous-default-export */
import Sidebar from '../Sidebar';
import './MainLayout.scss';
export default ({ activeMenuItem, children }) => {
  return (
    <div className="main-layout">
      <Sidebar />
      <div className="main-container">{children}</div>
    </div>
  );
};
